import React, {useState} from 'react'
import {
    ChatBubbleLeftEllipsisIcon, ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/solid";
import {
    prepareGenericFollowupJSONPromptMessages,
    prepareGenericJSONPromptMessages,
    prepareGenericPromptMessages,
} from "../../design/utils/open-ai-prompt-util";
import {generateContent} from "../../common/services/open-ai-service";
import ShowProgressSpinner from "../../common/ui/show-progress-spinner";
import CopyDataToClipboard from "../../common/ui/copy-data-to-clipboard";

const GenerateContentFromPrompt = ({
                                       label = '',
                                       noIcon = false,
                                       showCopyButton = false,
                                       promptTitle,
                                       promptContent,
                                       previousResponse = '',
                                       newPrompt = '',
                                       contentLineIndex = '',
                                       setContentText = undefined,
                                       afterContentGenerated = undefined,
                                       setApiCallInProgressFor = undefined,
                                       triggeredFor = '',
                                       sizeClass = 'px-1 py-1'
                                   }) => {
    const [inProgress, setInProgress] = useState(false);

    const initiateChatApiCall = async () => {
        setInProgress(true);

        if (setApiCallInProgressFor) {
            setApiCallInProgressFor(triggeredFor);
        }

        let promptMessages;

        if (previousResponse && newPrompt) {
            promptMessages = prepareGenericFollowupJSONPromptMessages(promptTitle, promptContent, previousResponse, newPrompt);
        } else {
            promptMessages = prepareGenericJSONPromptMessages(promptTitle, promptContent);
        }

        let generatedContent: any = await generateContent(promptMessages);

        if (afterContentGenerated) {
            afterContentGenerated(generatedContent?.content, contentLineIndex);
        } else if (setContentText) {
            setContentText({
                text: generatedContent?.content
            });
        }

        setInProgress(false);

        if (setApiCallInProgressFor) {
            setApiCallInProgressFor(null);
        }
    }

    return (
        <>
            <button
                onClick={initiateChatApiCall}
                className={`m-1 rounded flex items-center justify-center border button-green-outline ${sizeClass}`}>

                {!noIcon &&
                    <div className={`mx-1`}>
                        <ChatBubbleLeftRightIcon className="h-6 w-6"/>
                    </div>
                }

                {label && <span className="mx-1">{label}</span>}

                {inProgress &&
                    <ShowProgressSpinner
                        sizeClass="w-6 h-6"
                        dataFetchInProgress={inProgress}/>
                }

            </button>

            {showCopyButton &&
                <CopyDataToClipboard
                    value={promptContent}/>
            }
        </>
    )
}

export default GenerateContentFromPrompt
